import { render, staticRenderFns } from "./cninvmain.vue?vue&type=template&id=8151cf16&scoped=true"
import script from "./cninvmain.vue?vue&type=script&lang=js"
export * from "./cninvmain.vue?vue&type=script&lang=js"
import style0 from "./cninvmain.vue?vue&type=style&index=0&id=8151cf16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8151cf16",
  null
  
)

export default component.exports